import { secondToTime } from "../utils";
import { getCollectionItem } from "@/api/fmItemDetail";
import { useRoute } from "vue-router";
import { reactive, toRefs } from "vue";

export interface AudioDetail {
  coverFileUrl?: string;
  title1?: string;
  visitNum?: number;
  whetherCollect?: boolean;
  introduction?: string;
}

interface State {
  currentTab: number;
  tabList: string[];
  audioManager: HTMLAudioElement;
  audioDuration: string;
  audioCurrentTime: string;
  audioCurrentSlider: number;
  isPaused: boolean;
  audioDetail: AudioDetail;
}

export default function () {
  const route = useRoute();

  const state = reactive<State>({
    currentTab: 0,
    tabList: ["音频", "阅读"],
    // audio对象
    audioManager: new Audio(),
    // 当前音频的长度
    audioDuration: "00 : 00",
    // 当前音频的播放位置
    audioCurrentTime: "00 : 00",
    // 当前音频的播放进度条位置
    audioCurrentSlider: 0,
    // 是否暂停
    isPaused: true,
    // 课程信息
    audioDetail: {},
  });

  const onChangeCurrentTime = (value: number) => {
    state.audioManager.currentTime =
      (value / 100) * state.audioManager.duration;
  };

  // 暂停0 / 播放1 / 2上一首 / 3下一首
  const changePlayStatus = (isPaused: boolean) => {
    if (isPaused) {
      state.audioManager.play();
    } else {
      state.audioManager.pause();
    }
  };

  //   fm播放器初始化
  const initAudioPlayer = async () => {
    const { rows } = await getCollectionItem({
      id: route.params.id,
    });
    state.audioManager.src = rows.voiceSDPalyUrl;
    state.audioDetail.coverFileUrl = rows.coverFileUrl;
    state.audioDetail.title1 = rows.title1;
    state.audioDetail.visitNum = rows.visitNum;
    state.audioDetail.whetherCollect = rows.whetherCollect;
    state.audioDetail.introduction = rows.introduction;

    // 背景音频进入可以播放状态
    state.audioManager.addEventListener("canplaythrough", () => {
      state.audioDuration = secondToTime(state.audioManager.duration);
    });

    // 背景音频播放/暂停事件
    state.audioManager.addEventListener("play", () => {
      state.isPaused = false;
    });
    state.audioManager.addEventListener("pause", () => {
      state.isPaused = true;
    });

    // 背景音频播放进度更新事件
    state.audioManager.addEventListener("timeupdate", () => {
      state.audioCurrentTime = secondToTime(state.audioManager.currentTime);
      state.audioCurrentSlider =
        (state.audioManager.currentTime / state.audioManager.duration) * 100;
    });
  };

  return {
    ...toRefs(state),
    changePlayStatus,
    onChangeCurrentTime,
    initAudioPlayer,
  };
}
